function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import mapValues from 'lodash/mapValues';
import { circularFontFamily } from '../../fonts';
import * as colors from '../colors';
import { breakpoint } from '../../breakpoints';
var greys = colors.greys; // todo: change all styles below to suit zh
// - if should be similar to another language's typography (e.g. en), can import whatever parts of that and compose accordingly

var default_ = {
  fontFamily: circularFontFamily
};
var titleDefaults = {
  color: greys[100],
  fontWeight: 700,
  lineHeight: 1.25
};
var titleVariant = {
  '100': _defineProperty({
    fontSize: 40
  }, breakpoint.s, {
    fontSize: 24
  })
};
var headlineDefault = {
  color: greys[100],
  fontWeight: 700,
  lineHeight: 1.25
};
var headlineVariant = {
  '100': {
    fontSize: 24
  },
  '200': {
    fontSize: 18
  },
  '300': {
    fontSize: 16
  },
  '400': {
    fontSize: 14
  },
  '500': {
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'uppercase'
  },
  '600': {
    fontSize: '13px',
    fontWeight: 500,
    textTransform: 'uppercase'
  }
};
var bodyDefault = {
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5
};
var bodyVariant = {
  '100': {
    color: greys[80]
  },
  '100.Subtle': {
    color: greys[60]
  },
  '100.Disabled': {
    color: greys[40]
  },
  '100.Bold': {
    color: greys[80],
    fontWeight: 500
  }
};
var tabPanelDefault = {
  fontWeight: 400,
  color: greys[80],
  lineHeight: 1.25
};
var tabPanelVariant = {
  inactive: {
    fontSize: 16
  }
};
var labelVariant = {
  '100': bodyVariant['100']
};
var hintVariant = {
  '100': _objectSpread(_objectSpread({}, bodyVariant['100.Subtle']), {}, {
    fontSize: 12
  })
};
var errorVariant = {
  '100': _objectSpread(_objectSpread({}, bodyVariant['100']), {}, {
    fontSize: 12,
    color: colors.reds['50']
  })
};
export var typography = {
  title: mapValues(titleVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), titleDefaults), s);
  }),
  headline: mapValues(headlineVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), headlineDefault), s);
  }),
  body: mapValues(bodyVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), bodyDefault), s);
  }),
  tabPanel: mapValues(tabPanelVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), tabPanelDefault), s);
  }),
  label: mapValues(labelVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), bodyDefault), s);
  }),
  hint: mapValues(hintVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), bodyDefault), s);
  }),
  error: mapValues(errorVariant, function (s) {
    return _objectSpread(_objectSpread(_objectSpread({}, default_), bodyDefault), s);
  })
};